import 'tom-select';
import TomSelect from 'tom-select';

document.addEventListener('turbo:load', function () {
  console.log('Tom Select JS is connected PROPER.');

  const selectDancestyle = document.getElementById('select-dancestyle');
  if (selectDancestyle) {
    new TomSelect(selectDancestyle, {
      maxOptions: 100000,
      plugins: {
        remove_button: {
          title: 'Remove this dance style.',
        },
      },
      onItemAdd: function () {
        this.setTextboxValue('');
        this.refreshOptions();
      },
    });
  }

  const selectPostTypes = document.getElementById('select-post-types');
  if (selectPostTypes) {
    new TomSelect(selectPostTypes, {
      maxOptions: 100000,
      plugins: {
        remove_button: {
          title: 'Remove this dance style.',
        },
      },
      onItemAdd: function () {
        this.setTextboxValue('');
        this.refreshOptions();
      },
    });
  }

  const selectArtist = document.getElementById('select-artist');
  if (selectArtist) {
    new TomSelect(selectArtist, {
      maxOptions: null,
      plugins: {
        remove_button: { title: 'Remove this artist' },
      },
      onItemAdd: function () {
        this.setTextboxValue('');
        this.refreshOptions();
      },
    });
  }

  const selectMonth = document.getElementById('select-month');
  if (selectMonth) {
    new TomSelect(selectMonth, {
      plugins: {
        remove_button: { title: 'Remove month.' },
      },
      onItemAdd: function () {
        this.setTextboxValue('');
        this.refreshOptions();
      },
    });
  }

  const selectYear = document.getElementById('select-year');
  if (selectYear) {
    new TomSelect(selectYear, {
      plugins: {
        remove_button: { title: 'Remove year.' },
      },
      onItemAdd: function () {
        this.setTextboxValue('');
        this.refreshOptions();
      },
    });
  }

  const selectUser = document.getElementById('select-user');
  if (selectUser) {
    new TomSelect(selectUser, {
      maxOptions: 100000,
      plugins: {
        remove_button: { title: 'Remove month.' },
      },
      onItemAdd: function () {
        this.setTextboxValue('');
        this.refreshOptions();
      },
    });
  }

  const selectOrganizer = document.getElementById('select-organizer');
  if (selectOrganizer) {
    new TomSelect(selectOrganizer, {
      maxOptions: 100000,
      plugins: {
        remove_button: { title: 'Remove month.' },
      },
      onItemAdd: function () {
        this.setTextboxValue('');
        this.refreshOptions();
      },
    });
  }
});
